import React, {useEffect, useState} from "react";
import styled from "styled-components";

const LayoutPreview = styled.div `
  .link {
    background-color: ${props => props.linkColor ? props.linkColor + ' !important' : 'initial'};
    >.underline {
      background-color: ${props => props.linkColor ? props.linkColor + ' !important' : 'initial'};
    }
  }
  .button-accept {
    background-color: ${props => props.buttonColor ? props.buttonColor + ' !important' : 'initial'};
    border-color: ${props => props.buttonColor ? props.buttonColor + ' !important' : 'initial'};
  }
  .button-refuse {
    border-color: ${props => props.buttonColor ? props.buttonColor + ' !important' : 'initial'};
    >.text {
      background-color: ${props => props.buttonColor ? props.buttonColor + ' !important' : 'initial'};
    }
  }
  .button-learn-more {
    border-color: ${props => props.buttonColor ? props.buttonColor + ' !important' : 'initial'};
    >.text {
      background-color: ${props => props.buttonColor ? props.buttonColor + ' !important' : 'initial'};
    }
  }
  .switch-demo.active {
    background-color: ${props => props.activeSwitchColor ? props.activeSwitchColor + ' !important' : 'initial'};
  }
  .header-container {
    background-color: ${props => props.headerColor ? props.headerColor + ' !important' : 'initial'};
  }
  .popup-container {
    background-color: ${props => props.headerColor ? props.headerColor + ' !important' : 'initial'};
  }
  .logo-container > svg > polygon {
    fill: ${props => props.headerColor ? props.headerColor + ' !important' : 'initial'};
  }
  .content-container {
    background-color: ${props => props.backgroundColor ? props.backgroundColor + ' !important' : 'initial'};
  }
  .font-preview-content {
    background-color: ${props => props.backgroundColor ? props.backgroundColor + ' !important' : 'initial'};
  }
  .popup-container .title, .popup-container .text {
    background-color: ${props => props.textColor ? props.textColor + ' !important' : 'initial'};
  }
  .font-preview-content {
    color: ${props => props.textColor ? props.textColor + ' !important' : 'initial'};
  }
`

export default function CmpLayoutPreview(props) {

  return (
    <LayoutPreview {...props} id="design-preview" className={props.logoUrl ? "" : "no-logo"}>
      <div className="popup-container">
        <div className="header-container">
          <div className={`logo-container ${props.logoUrl ? "" : "hidden"}`}>
            <div className="logo"><img src={props.logoUrl}/></div>
            <div className="top-bg"></div>
          </div>
        </div>
        <div className={`content-container ${props.logoUrl ? "wrapper" : ""}`}>
          <div className="head-image"></div>
          <div className="text-container">
            <span className="title"></span>
            <span className="text"></span><span className="link"><span className="underline"></span></span><span className="text text2"></span>
            <span className="text text2"></span><span className="text"></span><span className="text text3"></span>
            <span className="text"></span><span className="text text3"></span><span className="text text2"></span>
            <span className="text text3"></span><span className="text text2"></span><span className="text"></span><span className="text text2"></span>
            <span className="text text2"></span><span className="text text3"></span><span className="text text2"></span>
            <span className="text text3"></span><span className="link"><span className="underline"></span></span><span className="text text2"></span><span className="text"></span><span className="text text2"></span>
            <span className="text text2"></span><span className="text"></span>
          </div>
          <div className="switches-container">
            <div className="select">
              <div className="spacer">
                <div className="text-content">
                  <div className="text"></div><div className="link"><div className="underline"></div></div>
                </div>
                <div className="switch-demo active"></div>
              </div>
            </div>
            <div className="select">
              <div className="spacer">
                <div className="text-content">
                  <div className="text"></div><div className="link"><div className="underline"></div></div>
                </div>
                <div className="switch-demo"></div>
              </div>
            </div>
            <div className="select">
              <div className="button-save">
              </div>
            </div>
          </div>
          <div className="buttons-container">
            <div className="button-demo button-accept">
            </div>
            <div className="button-demo button-learn-more">
              <div className="text"></div>
            </div>
            <div className="button-demo button-refuse">
              <div className="text"></div>
            </div>
          </div>
        </div>
      </div>
    </LayoutPreview>)
}
